import ProductAjaxService from "./AjaxService";

export default class CartActions extends ProductAjaxService {
    constructor() {
        super();
        this.addToCart();
        this.deleteFromCart();
        this.setCount();

    }

    //After load page
    getCart() {
        this._GET(this.getCartURL, this.updateSmallCarts);
    }

    addToCart() {
        let self = this;
        $(document).on('click', '.add-to-cart:not(.btn-empty)', function (e) {
            e.preventDefault();
            let ID = $(this).attr('data-id');
            if(!ID) {
                console.warn('Please set product ID');
                return false;
            }
            self._POST(self.addToCartURL, {product_id: ID}, self.updateSmallCarts);
            $('.add-to-cart[data-id='+ ID +']').addClass('active btn-blue');
        });
    }

    deleteFromCart() {
        let self = this;
        $(document).on('click', '.delete_from_cart', function (e) {
            e.preventDefault();
            let ID = $(this).attr('data-id'),
                confName = 'confirm:delete';
            if(!ID) {
                console.warn('Please set product ID');
            }

            //Confirm delete
            $(document).bind(confName, function () {
                $(document).unbind(confName);

                self._POST(self.deleteCartURL, {product_id: ID}, self.updateSmallCarts);
                $('.add-to-cart[data-id='+ ID +']').removeClass('active btn-blue');
            });
            self.confirmDelete(confName);
        });
    }

    setCount() {
        let self = this,
            timer = '';
        $(document).bind('trigger.count.product', function (e, id, count) {
            clearTimeout(timer);
            timer = setTimeout(function () {
                self._POST(self.setCartURL, {product_id: id, count: count}, self.updateSmallCarts);
            }, 300);
        });
    }

    updateSmallCarts(res) {
        if(res.success) {

            let $smallItems = $('.ajax_small_items'),
                $priceTotal = $('.ajax_price_info_total'),
                $totalCount = $('.ajax_count_orders'),
                $cartModal = $('.ajax_open_cart_modal'),
                $cartNote = $('.order-min-info');

            (window.cart_min_cap >= res.data.price) ? $cartNote.show() : $cartNote.hide();

            if(res.data.count > 0) {
                $smallItems.html(res.data.html);
                $priceTotal.html(res.data.price.toLocaleString('ru-RU', {maximumFractionDigits: 2, minimumFractionDigits: 2}));
                $totalCount.html(res.data.count);
                $('.cart-full--link').show();
                $('.cart-empty--link').hide();

                $cartModal.addClass('open-popup');
            } else {
                //Check cart page
                //note: reload for redirect to index
                if($('.wrap_page.cart-page').length || $('.wrap_page.checkout-page').length) {
                    location.reload();
                }

                $smallItems.html(res.data.html);
                $totalCount.html(0);
                $('.cart-full--link').hide();
                $('.cart-empty--link').show();

                $cartModal.removeClass('open-popup');
            }
            $(document).trigger('trigger.update.price.count');

            if(res.data.is_add) {
                $(document).trigger('trigger.show.popup', ['cartModal']);

                if(res.data.self_data) {
                    let productData = {
                        name: res.data.self_data.name,
                        id: res.data.self_data.id,
                        price: res.data.self_data.price,
                        brand: res.data.self_data.brand,
                        category: res.data.self_data.breadcrumbs_str,
                        quantity: res.data.self_data.quantity,
                    };
                    window.GA.pushAddProductToCart(productData);
                }
            }

            if(res.data.is_delete) {
                if(res.data.self_data) {
                    let productData = {
                        name: res.data.self_data.name,
                        id: res.data.self_data.id,
                        price: res.data.self_data.price,
                        brand: res.data.self_data.brand,
                        category: res.data.self_data.breadcrumbs_str,
                        quantity: res.data.self_data.quantity,
                    };
                    window.GA.pushRemoveProductFromCart(productData);
                }
            }
        }
    }
    checkAvailableProducts(callback) {
        this._GET(this.checkAvailableURL, function (res) {
            callback(res);
        });
    }
}
